import { render, staticRenderFns } from "./callView.vue?vue&type=template&id=8a587446&scoped=true"
import script from "./callView.vue?vue&type=script&lang=js"
export * from "./callView.vue?vue&type=script&lang=js"
import style0 from "./callView.vue?vue&type=style&index=0&id=8a587446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a587446",
  null
  
)

export default component.exports